import { useNavigate } from 'react-router-dom';
import { Button } from '../../design-system/components/Button';
import { useAuthStore } from '../../features/auth/store';

export function Header() {
  const user = useAuthStore((s) => s.user);
  const tenantSlug = useAuthStore((s) => s.tenantSlug);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/auth/login', { replace: true });
  };

  return (
    <header className="dash-header">
      <div className="dash-header__brand">Leddo Copilot</div>
      <div className="dash-header__actions">
        <span className="dash-header__user">
          {user?.email ?? ''}
          {tenantSlug !== null ? (
            <span className="dash-header__tenant"> — {tenantSlug}</span>
          ) : null}
        </span>
        <Button variant="ghost" onClick={() => void handleLogout()}>
          Sair
        </Button>
      </div>
    </header>
  );
}
